import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import Loading from '../Loading';
import { toast } from 'react-toastify';
import EstudianteFilter from '../Filters/EstudianteFilter';
import JornadaAnioNivelCurso from '../Filters/JornadaAnioNivelCurso';
import agendaService from '../../services/agendaService';
import utils from '../../utils/generalFunctions';
import documentService from '../../services/documentService';
import types from "../../services/types";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DocumentItem from '../documentItem';


const AgendaForm = (props) => {
    const { agendaId, onClose, ReadOnly, ReadOnlyEstudent  } = props; 
    const initData ={
        agendaId: 0,
        schoolYearId:"",
        journeyId: "",
        educationLevelId: "0",
        gradeId:"",
        courseId:"",
        studentId:"",
        startDate:"",
        endDate:"",
        title: "",
        description: "",
    };
    const [formData, setFormData] = useState(initData);
    const [documents, setDocuments] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const filteReference = useRef(null);
    const studentFilteReference = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeRichText = (value) => {
        setFormData(prevState => ({
            ...prevState,
            description: value
        }));
    };

    useEffect(() => {
        const fetchJourneys = async () => {
            try {
                setShowLoading(false);
                if (agendaId && agendaId>0) {
                    const event = await agendaService.getAgendaById(agendaId);
                    await fetchDocuments(agendaId);
                    setFormData((prevState) => ({ ...prevState, ...event }));
                    studentFilteReference?.current?.setFormValues({ 
                        studentId: event.studentId,
                    });
                    filteReference?.current?.setFormValues({ 
                        studentId: event.studentId,
                        journeyId: event.journeyId,
                        schoolYearId: event.schoolYearId,
                        educationLevelId: event.educationLevelId,
                        courseId: event.courseId
                    });
                }
            } catch (error) {
                console.error("Error al obtener listas de formulario:", error);
            }
        };
    
        fetchJourneys();
    }, [agendaId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
       
        const cursos = filteReference?.current?.getCursos();
        if (cursos.length > 0) {
            const gradeId = cursos.find(c => String(c.courseId) === String(formData.courseId))?.gradeId;
            setFormData(prevState => ({
                ...prevState, gradeId: gradeId
            }));
            formData["gradeId"] = gradeId;
        }

         // Validación básica
         const requiredFields = ['title', 'description', 'startDate', 'endDate'];
         for (let field of requiredFields) {
             if (!formData[field]) {
                 toast.error("Por favor, completa todos los campos obligatorios marcados con un (*)", {
                     position: "top-right",
                     autoClose: 5000,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "light",
                   });
                 return;
             }
         }
 

        setShowLoading(true);
        try {
            let response;
            if (formData.agendaId > 0) {
                response = await agendaService.updateAgenda(formData);
            } else {
                response = await agendaService.createEventoAgenda(formData);
            }
            if (response && response.agendaId) {

                 if( documents &&
                     documents.length > 0 &&
                     response.agendaId > 0 ) {
                          for(let i=0; i < documents.length; i++)
                          {
                                let doc = documents[i];
                                if(doc.documentId===0){
                                    try {
                                        const imgResponse = await documentService.addDocument(
                                            types.documentTypes.AGENDA_FILES,
                                            doc,
                                            agendaId,
                                            doc.name,
                                            doc.size,
                                            doc.type
                                        );
                                        console.log(imgResponse);
                                    } catch (error) {
                                        console.error(
                                            "Hubo un error al subir el documento adjunto:",
                                            error
                                        );
                                    }
                                }
                          }
                }

                Swal.fire("Felicidades!", "Evento guardado con éxito!", "success");
                if (onClose) onClose();
                setFormData(initData);
            } else {
                Swal.fire("Ha ocurrido un error", "Por favor intentelo más tarde", "error");
            }
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            Swal.fire("Ha ocurrido un error", "Por favor intentelo más tarde", "error");
        }
        setShowLoading(false);
    };

    const handleFilterChange = (newFilters) => {
        // Actualiza el estado de filters con los nuevos valores
        setFormData(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    const studentInfoChange = (student) => {
        if(student){
        filteReference?.current?.setFormValues({ 
            journeyId: student.journeyId,
            schoolYearId: student.schoolYearId,
            educationLevelId: student.educationLevelId,
            courseId: student.courseId});
        }else{
            if(agendaId===0){
            filteReference?.current?.setFormValues({ 
                journeyId: '0',
                schoolYearId: '0',
                educationLevelId: '0',
                courseId: '0'});
            }
        }
    };

    const handleFileChange = (e) => {
        const files = e.target.files;
        if (files && files.length>0) {
            if(e.target.id==="btnAgendaDocuments"){
                let newFiles = [];
                for(let i=0; i<files.length; i++){
                    newFiles.push(files[i]);
                }
                const arrayFiles= [...documents, ...newFiles].map(f=>{
                    if(!f.documentId) f.documentId = 0;
                    return f;
                })
                console.log(arrayFiles);
                setDocuments(arrayFiles);
            }
        }
    }

    const deleteDocument = async(document)=>{
        if(document.documentId>0){
            Swal.fire({
                title: 'Esta seguro que desea eliminar este documento?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar!'
                }).then(async(result) => {
                if (result.isConfirmed) {
                    try{
                    await documentService.removeDocument(document.documentId);
                    Swal.fire(
                    'Felicidades!',
                    'Documento eliminado exitosamente!',
                    'success'
                    );
                    await fetchDocuments(agendaId);
                    }catch(error){
                    console.log(error);
                    Swal.fire(
                        "Ha ocurrido un error",
                        "Por favor intentelo mas tarde",
                        "error"
                    );
                    }
                }
                })
        }else{
            const docs= documents.filter(doc =>{
                if(doc.name!==document.name)
                return doc;
            });
            setDocuments(docs);
        }
    }
    
    const fetchDocuments = async (agendaId) => {
        try {
          if (agendaId && agendaId>0) {
            const documentArray = await documentService.getDocumentsToCustomId(types.documentTypes.AGENDA_FILES, agendaId);
            if(documentArray && documentArray.length > 0){
              const docs = documentArray.map(d=>{
                return d;
              });
              setDocuments(docs);
            }else{
              setDocuments([]);
            }
          }
        } catch (error) {
          console.error("Error al obtener listas de formulario:", error);
        }
    };

    return (
        <>
        {showLoading && <Loading />}

        {!showLoading && (
            <div className="container-fluid mt-4">
                {!ReadOnlyEstudent && (
            <p className="text-muted">Por favor, completa todos los campos para guardar un evento en la agenda escolar.</p>
                )}
            <form  onSubmit={handleSubmit} className="row g-2 align-items-center mb-3">
                        
                        {!ReadOnlyEstudent && (
                            <>
                                <div className="col-md-12">
                                    <EstudianteFilter 
                                        callback={handleFilterChange} 
                                        callbackStudentInfo={studentInfoChange}
                                        ref={studentFilteReference}
                                        properties={
                                            {
                                                className: 'w-100',
                                            }
                                        }
                                        />
                                </div>
                                <div className="col-md-12">
                                        <JornadaAnioNivelCurso
                                                callback={handleFilterChange}
                                                ref={filteReference}
                                                properties={
                                                    {
                                                        className: 'col-md-6',
                                                        id:'formAgenda',
                                                        filtro:true
                                                    }
                                                }
                                            />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="startDate" className="col-form-label  text-sm-right">Fecha Inicio *</label>
                                        <input type="datetime-local" className="form-control" id="startDate" name="startDate" 
                                            readOnly={ReadOnly} value={formData.startDate} onChange={handleChange} required />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="endDate" className="col-form-label  text-sm-right">Fecha Final *</label>
                                        <input type="datetime-local" className="form-control" id="endDate" name="endDate" 
                                            readOnly={ReadOnly} value={formData.endDate} onChange={handleChange} required />
                                    </div>
                            </>
                            )}
                            <div className="col-md-12 mb-12">
                                <label htmlFor="title" className="col-form-label  text-sm-right">Titulo *</label>
                                <input type="text" className="form-control" id="title" name="title" 
                                    readOnly={ReadOnly} value={formData.title} onChange={handleChange} required />
                            </div>
                            <div className="col-md-12 mb-12">                                
                                <div className="mb-3">
                                    <label className="form-label">Descripción * </label>
                                    {!ReadOnlyEstudent && (
                                        <ReactQuill 
                                        value={formData.description}
                                        onChange={handleChangeRichText}
                                        placeholder="Escribe el contenido del evento..."
                                        />
                                    )}
                                    {ReadOnlyEstudent && (
                                        <div dangerouslySetInnerHTML={{ __html: formData.description }} />
                                    )}

                                </div>
                            </div>
                            {!ReadOnlyEstudent && (
                            <>
                                <div className="col-md-4 d-flex flex-column">
                                        {!ReadOnly  && (
                                        <label className="btn btn-primary">
                                            <i class="fa-solid fa-file-arrow-up"></i> Subir Documentos
                                            <input
                                                type="file"
                                                id="btnAgendaDocuments"
                                                className="form-control d-none"
                                                onChange={handleFileChange}
                                                readOnly={ReadOnly}
                                                multiple={true}
                                            />
                                        </label>
                                        )}
                                </div>
                            </>
                            )}
                            <div className='row'>
                               <table className='w-auto ml-20 mt-20'>
                                    {documents && documents.length> 0 && documents?.map((doc) => (
                                        <DocumentItem 
                                            document={doc}
                                            ReadOnly={ReadOnlyEstudent}
                                            EnableDelete={ReadOnly}
                                            deleteDocument={deleteDocument}
                                        />
                                    ))}
                                </table>
                            </div>
                            {!ReadOnlyEstudent && (
                            <div className="row mt-5">
                                <div className="col-md-2 center">
                                    {!ReadOnly  && (
                                        <button type="submit" className="btn btn-primary">Guardar</button>
                                    )}
                                </div>
                            </div>
                            )}
            </form>
            
            </div>
        )}
        </>
    );
}

export default AgendaForm;
